import React, { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import ReactDatePicker from 'react-datepicker';
import { DEFAULT_DATE_FORMATE } from '../../constents';
import SelectProcedureCode from './SelectProcedureCode';
import ModifileUnit from './ModifileUnit';
import SelectProblem from './SelectProblem';
import TreatTemletList from './TreatTemletList';
import { addDays, format } from 'date-fns';
import setUiMessage from '../../Utilities/Tostify';
import { useSelector } from 'react-redux';
//import Select from 'react-select';

function MatCounselingPopup({
  treatmentId,
  handleClose,
  handleReload,
  patientId,
  appId,
  visitId,
}) {
  const { user } = useSelector((state) => state.auth);
  const [allData, setAllData] = useState(false);
  const [provider, setProvider] = useState('');
  const [resource, setResource] = useState('');
  const [reviewIn, setReviewIn] = useState('');

  const [treatGenDate, setTreatGenDate] = useState(new Date());
  const [treatGenDatePickerIsOpen, setTreatGenDatePickerIsOpen] =
    useState(false);
  const [reviewInDate, setReviewInDate] = useState('');

  const [procId, setProcId] = useState(0);
  const [procFrom, setProcFrom] = useState(1);
  const [probIds, setProbIds] = useState('');

  const [mod1, setMod1] = useState('');
  const [mod2, setMod2] = useState('');
  const [mod3, setMod3] = useState('');
  const [mod4, setMod4] = useState('');
  const [unit, setUnit] = useState('');
  const [evalCodeId, setEvalCodeId] = useState('');

  const [treatProblemArea, setTreatProblemArea] = useState('');
  const [treatPresentProblemArea, setTreatPresentProblemArea] = useState('');
  const [treatBehavArea, setTreatBehavArea] = useState('');

  const [treatDuration, setTreatDuration] = useState('');
  const [treatMode, setTreatMode] = useState('');

  const [treatStDate, setTreatStDate] = useState(new Date());
  const [treatStPickerIsOpen, seTtreatStPickerIsOpen] = useState(false);

  const [probTemArr, setProbTemArr] = useState(null);
  const [presntProbTemArr, setPresntProbTemArr] = useState(null);
  const [behavTemArr, setBehavTemArr] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        if (patientId && appId) {
          const response = await post(
            'api/patient/treatmentPlan/openMatCounselingPlan',
            {
              patientId: patientId,
              appointmentId: appId,
              visitId: visitId,
              treatmentId: treatmentId,
              staffUserId: user?.id,
              userType: '1',
            },
          );
          if (response.status === 200) {
            setAllData(response?.data);
            setProbTemArr(response?.data?.selPblmTempletArrs);
            setPresntProbTemArr(response?.data?.prePblmTempletArrs);
            setBehavTemArr(response?.data?.behTempletArrs);

            setProvider(response?.data?.selProviderId);
            setResource(response?.data?.selResourceId);
            setReviewIn(response?.data?.reviewSel);
            setReviewInDate(response?.data?.reviewDate);
            setTreatGenDate(new Date(response?.data?.therapyDate));

            setProcFrom(response?.data?.procedureForm);
            setProcId(response?.data?.procedure_id);

            setMod1(response?.data?.modifier_one || '');
            setMod2(response?.data?.modifier_two || '');
            setMod3(response?.data?.modifier_three || '');
            setMod4(response?.data?.modifier_four || '');
            setUnit(response?.data?.unit || '');

            setTreatProblemArea(response?.data?.select_problem || '');
            setTreatPresentProblemArea(
              response?.data?.presenting_problem || '',
            );
            setTreatBehavArea(response?.data?.behavior || '');

            setTreatDuration(response?.data?.durSel || '');
            setTreatMode(response?.data?.treatmentModeSel || '');

            // const treatmode = response?.data?.treatmentModeList?.filter((o) =>
            //   response?.data?.treatmentModeSel?.includes(o.value)
            // );
            // setTreatMode(treatmode);

            setTreatStDate(new Date(response?.data?.stDate));
            setEvalCodeId(response?.data?.evaluate_code_id || '');
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patientId, appId, visitId, user, treatmentId]);

  function openDatePicker() {
    setTreatGenDatePickerIsOpen(!treatGenDatePickerIsOpen);
  }

  function handleDateSelect(dateEvent) {
    setTreatGenDatePickerIsOpen(!treatGenDatePickerIsOpen);
  }

  function openStDatePicker() {
    seTtreatStPickerIsOpen(!treatStPickerIsOpen);
  }

  function handleStDateSelect(dateEvent) {
    seTtreatStPickerIsOpen(!treatStPickerIsOpen);
  }

  const handleProcCode = (data) => {
    setProcFrom(data[1]);
    setProcId(data[0]);
    setMod1(data[2] || '');
    setMod2(data[3] || '');
    setMod3(data[4] || '');
    setMod4(data[5] || '');
    setUnit(data[6] || '');
    setEvalCodeId(data[7] || '');
  };

  const handleproblems = (data) => {
    setProbIds(data);
  };

  const hadleProblemText = (data, actionType) => {
    let newStr = data ? data.split('-') : null;
    newStr = newStr && newStr.slice(1).join('-');
    if (actionType === 'add') {
      setTreatProblemArea(
        treatProblemArea ? treatProblemArea + '\n' + newStr : newStr,
      );
    } else {
      setTreatProblemArea(treatProblemArea?.replace(newStr, ''));
    }
  };

  const apiCallFun = async (id, name) => {
    try {
      if (id) {
        const response = await post(
          'api/patient/treatmentPlan/mhtpTempletListSelect',
          {
            id: id,
          },
        );
        if (response.status === 200) {
          if (name === 'selPblm') {
            setTreatProblemArea(
              treatProblemArea
                ? treatProblemArea + '\n' + response?.data
                : response?.data,
            );
          } else if (name === 'prePblm') {
            setTreatPresentProblemArea(
              treatPresentProblemArea
                ? treatPresentProblemArea + '\n' + response?.data
                : response?.data,
            );
          } else if (name === 'behavior') {
            setTreatBehavArea(
              treatBehavArea
                ? treatBehavArea + '\n' + response?.data
                : response?.data,
            );
          }
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  useEffect(() => {
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(treatProblemArea, 'text/html');
    const textContent = parsedHtml.body.textContent;
    setTreatProblemArea(textContent);
  }, [treatProblemArea]);

  const handleReviewList = (e) => {
    setReviewIn(e.target.value);
    let days = e.target.options[e.target.selectedIndex].text
      ? e.target.options[e.target.selectedIndex].text.split(' ')[0]
      : '';
    if (days) {
      setReviewInDate(addDaysAndFormat(days));
    } else {
      setReviewInDate('');
    }
  };

  const addDaysAndFormat = (days) => {
    const currentDate = new Date();
    const finalDate = addDays(currentDate, days);
    const formattedDate = format(finalDate, DEFAULT_DATE_FORMATE);
    return formattedDate;
  };

  const handleSaveUpdateTreatPlan = async (treatmentId) => {
    try {
      if (!procId) {
        setUiMessage('err', 'Select procedure first.');
      } else {
        const response = await post(
          'api/patient/treatmentPlan/saveMatCounselForm',
          {
            treatmentId: treatmentId,
            provider_id: provider,
            resource_id: resource,
            therapy_date: format(treatGenDate, DEFAULT_DATE_FORMATE),
            procFrom: procFrom,
            procId: procId,
            evaluateCodeId: evalCodeId,
            mod1: mod1,
            mod2: mod2,
            mod3: mod3,
            mod4: mod4,
            unit: unit,
            problem_id: probIds,
            review_in: reviewIn,
            review_date: reviewInDate,
            behavior: treatBehavArea,
            presentingPblm: treatPresentProblemArea,
            selPblm: treatProblemArea,
            treatment_duration: treatDuration,
            start_date: format(treatStDate, DEFAULT_DATE_FORMATE),
            treatment_mode: treatMode,
            staffUserId: user?.id,
          },
        );
        if (response.status === 200) {
          // handleReload('treat');
          // handleReload('goal');
          handleReload('both');
          handleClose();
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  return (
    <div className="modalBackground">
      <div className="main-contnr tp-comn-poup-main-con center-popup qhide">
        <div className="main-contnr-hdr flex-sec">
          <div className="hdr-pt-info">
            <span className="black-txt clear-right10">Treatment Plan:</span>
            {allData?.patientName}
            <span className="red"> | </span>
            ID: {allData?.chartNo}
            <span className="red"> | </span>
            {allData?.age} yrs-[{allData?.gender?.substr(0, 1)}]
            <span className="red"> | </span>
            DOB:{allData?.dob}
          </div>
          <div className="Close" onClick={handleClose}>
            X
          </div>
        </div>
        <div className="main-contnr-bdy tp-comn-poup-bdy">
          <div className="pop-up-prnt-blk flex-sec">
            <div className="width50">
              <div className="appt-hx-fa-rw">
                <span className="txt-label clear-top5">Provider:</span>
                <span className="txt-val">
                  <select
                    className="book-appt-dd width100"
                    data-placeholder="Select Provider"
                    value={provider}
                    onChange={(e) => setProvider(e.target.value)}
                  >
                    <option value="">{''}</option>
                    {allData?.providerList?.map((data, i) => (
                      <option key={i} value={data?.id}>
                        {data?.providerName}
                      </option>
                    ))}
                  </select>
                </span>
              </div>
              <div className="appt-hx-fa-rw">
                <span className="txt-label clear-top5">Resource:</span>
                <span className="txt-val">
                  <select
                    className="book-appt-dd width100"
                    value={resource}
                    onChange={(e) => setResource(e.target.value)}
                  >
                    <option value="">{''}</option>
                    {allData?.resourceList?.map((data, i) => (
                      <option key={i} value={data?.id}>
                        {data?.resourceName}
                      </option>
                    ))}
                  </select>
                </span>
              </div>
              <div className="appt-hx-fa-rw">
                <span className="txt-label clear-top5">Date:</span>
                <span
                  className="value"
                  style={{ display: 'flex', flexBasis: '62%' }}
                >
                  <ReactDatePicker
                    selected={treatGenDate}
                    onChange={(date) => setTreatGenDate(date)}
                    onClickOutside={openDatePicker}
                    open={treatGenDatePickerIsOpen}
                    onSelect={handleDateSelect}
                    className="app-date-picker"
                    dateFormat={DEFAULT_DATE_FORMATE}
                    maxDate={new Date()}
                  />
                  <img
                    width="13%"
                    src="./images/calendar-icon.png"
                    alt=""
                    onClick={openDatePicker}
                    style={{ marginLeft: '7px' }}
                  />
                </span>
              </div>
              <div className="appt-hx-fa-rw">
                <span className="txt-label"> Review in:</span>
                <span className="txt-val">
                  <select
                    className="book-appt-dd"
                    data-placeholder="Select"
                    value={reviewIn}
                    onChange={(e) => handleReviewList(e)}
                    style={{ width: '42%' }}
                  >
                    <option value="">{''}</option>
                    {allData?.reviewList?.map((data, i) => (
                      <option key={i} value={data?.id}>
                        {data?.title}
                      </option>
                    ))}
                  </select>
                  <input
                    type="text"
                    className="apptTime clear-left10 width50"
                    placeholder="mm-dd-yyyy"
                    value={reviewInDate}
                    readOnly={true}
                  />
                </span>
              </div>
            </div>
            <div className="width50">
              {allData && (
                <SelectProcedureCode
                  rendercommonFormData={allData}
                  prefProc={allData?.prefOrderList}
                  patLabOrder={allData?.patLabOrderList}
                  patientId={patientId}
                  calback={handleProcCode}
                />
              )}
              <div className="width100 flex-sec clear-top10">
                <div className="width100 grid-sec">
                  {allData && (
                    <ModifileUnit
                      dataArr={allData?.modifier}
                      title={'M1'}
                      calback={(data) => setMod1(data)}
                      seletedval={mod1}
                    />
                  )}
                </div>
                <div className="width100 grid-sec">
                  {allData && (
                    <ModifileUnit
                      dataArr={allData?.modifier}
                      title={'M2'}
                      calback={(data) => setMod2(data)}
                      seletedval={mod2}
                    />
                  )}
                </div>
                <div className="width100 grid-sec">
                  {allData && (
                    <ModifileUnit
                      dataArr={allData?.modifier}
                      title={'M3'}
                      calback={(data) => setMod3(data)}
                      seletedval={mod3}
                    />
                  )}
                </div>
                <div className="width100 grid-sec">
                  {allData && (
                    <ModifileUnit
                      dataArr={allData?.modifier}
                      title={'M4'}
                      calback={(data) => setMod4(data)}
                      seletedval={mod4}
                    />
                  )}
                </div>
              </div>
              {/* <div className="width100 clear-top10">
                <span className="label clear-right10">Unit:</span>
                <span className="value">
                  <select
                    className="mod-dd"
                    style={{ width: '20%' }}
                    value={unit}
                    onChange={(e) => setUnit(e.target.value)}
                  >
                    <option value=""></option>
                    {allData?.unitArr?.map((data, i) => (
                      <option key={i} value={data?.id}>
                        {data?.val}
                      </option>
                    ))}
                  </select>
                </span>
              </div> */}
            </div>
          </div>
          <div className="tp-comon-popup-dx-sec pop-up-prnt-blk">
            {allData && (
              <SelectProblem
                key={allData?.problemList}
                rendercommonFormData={allData?.problemList || []}
                patActProbList={allData?.patActProbList}
                prefProbList={allData?.prefProbList}
                callBack={handleproblems}
                hadleProblemText={hadleProblemText}
              />
            )}

            <div className="dx-bloc-tmplt flex-sec width100 clear-top10">
              {probTemArr && (
                <TreatTemletList
                  listArr={probTemArr}
                  apiCallFun={apiCallFun}
                  editFun={null}
                  delFun={null}
                  name={'selPblm'}
                />
              )}

              <div className="dx-bloc-tmplt-rt">
                <textarea
                  className="dx-area"
                  placeholder=""
                  value={treatProblemArea}
                  onChange={(e) => setTreatProblemArea(e.target.value)}
                ></textarea>
              </div>
            </div>
          </div>
          <div className="tp-comon-popup-dx-sec pop-up-prnt-blk">
            <span className="pop-up-sb-hdr width100">Presenting Problem</span>
            <div className="dx-bloc-tmplt flex-sec width100">
              {presntProbTemArr && (
                <TreatTemletList
                  listArr={presntProbTemArr}
                  apiCallFun={apiCallFun}
                  editFun={null}
                  delFun={null}
                  name={'prePblm'}
                />
              )}
              <div className="dx-bloc-tmplt-rt">
                <textarea
                  className="dx-area"
                  placeholder="Write here or select template from left side..."
                  value={treatPresentProblemArea}
                  onChange={(e) => setTreatPresentProblemArea(e.target.value)}
                ></textarea>
              </div>
            </div>
          </div>
          <div className="tp-comon-popup-dx-sec pop-up-prnt-blk">
            <span className="pop-up-sb-hdr width100">Behavior</span>
            <div className="dx-bloc-tmplt flex-sec width100">
              {behavTemArr && (
                <TreatTemletList
                  listArr={behavTemArr}
                  apiCallFun={apiCallFun}
                  editFun={null}
                  delFun={null}
                  name={'behavior'}
                />
              )}
              <div className="dx-bloc-tmplt-rt">
                <textarea
                  className="dx-area"
                  placeholder="Write here or select template from left side..."
                  value={treatBehavArea}
                  onChange={(e) => setTreatBehavArea(e.target.value)}
                ></textarea>
              </div>
            </div>
          </div>
          <div className="pop-up-prnt-blk flex-sec">
            <div className="width50">
              <div className="appt-hx-fa-rw">
                <span className="txt-label clear-top5">
                  Treatment duration:
                </span>
                <span className="txt-val">
                  <select
                    className="book-appt-dd width100"
                    data-placeholder="Select"
                    value={treatDuration}
                    onChange={(e) => setTreatDuration(e.target.value)}
                  >
                    <option value="">{''}</option>
                    {allData?.durationList?.map((data, i) => (
                      <option key={i} value={data?.id}>
                        {data?.title}
                      </option>
                    ))}
                  </select>
                </span>
              </div>
              <div className="appt-hx-fa-rw">
                <span className="txt-label clear-top5"> Treatment mode:</span>
                <span className="txt-val">
                  <select
                    className="book-appt-dd width100"
                    data-placeholder="Select"
                    value={treatMode}
                    onChange={(e) => setTreatMode(e.target.value)}
                  >
                    <option value="">{''}</option>
                    {allData?.treatmentModeList?.map((data, i) => (
                      <option key={i} value={data?.value}>
                        {data?.label}
                      </option>
                    ))}
                  </select>
                  {/* <Select
                    value={treatMode || ''}
                    options={allData?.treatmentModeList}
                    isMulti
                    onChange={(e) => setTreatMode(e)}
                  /> */}
                </span>
              </div>
            </div>
            <div className="width50">
              <div className="appt-hx-fa-rw">
                <span className="txt-label clear-top5">Start date:</span>
                <span
                  className="value"
                  style={{ display: 'flex', flexBasis: '62%' }}
                >
                  <ReactDatePicker
                    selected={treatStDate}
                    onChange={(date) => setTreatStDate(date)}
                    onClickOutside={openStDatePicker}
                    open={treatStPickerIsOpen}
                    onSelect={handleStDateSelect}
                    className="app-date-picker"
                    dateFormat={DEFAULT_DATE_FORMATE}
                  />
                  <img
                    width="13%"
                    src="./images/calendar-icon.png"
                    alt=""
                    onClick={openStDatePicker}
                    style={{ marginLeft: '7px' }}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="gnrl-dtl-btn-rw">
          {(allData?.formAction === 'Update' && (
            <button
              className="actn-yes"
              onClick={() => handleSaveUpdateTreatPlan(treatmentId)}
            >
              Update
            </button>
          )) ||
            (allData?.formAction === 'Save' && (
              <button
                className="actn-yes"
                onClick={() => handleSaveUpdateTreatPlan(treatmentId)}
              >
                Save
              </button>
            ))}

          <button className="actn-No" onClick={handleClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default MatCounselingPopup;
